import React from "react";
import { Container, StyledFillEmailIcon } from "./styles";
export const ArticleThemeSignUpButtonDisplay = () => /*#__PURE__*/React.createElement(Container, {
  "data-qa": "article-theme-sign-up-button-display"
}, /*#__PURE__*/React.createElement(StyledFillEmailIcon, null), "GET OUR NEWSLETTER");
ArticleThemeSignUpButtonDisplay.displayName = "ArticleThemeSignUpButtonDisplay";